/* eslint-disable sort-keys */
/* eslint-disable max-lines */
const shared = {
    theme: {
        colors: {
            avatarBorder: '#38516E',
            avatarText: '#38516E',
            attachmentFileTitle: '#008AFF',
            attachmentFileDownload: '#008AFF',
            attachmentFileIcon: '#008AFF',
            attachmentFileIconBackground: '#D0DCEB',
            attachmentFileBorder: '#E7ECF1',
            attachmentFileHoverBackground: '#F2F3F5',
            attachmentFileDownloadLinkHover: '#E6E8EC',

            lightBoxOverlay: 'rgba(0, 0, 0, 0.85)',
            lightBoxHeaderBackground: 'rgba(0,0,0,0.2)',
            lightBoxText: '#FFFFFF',
            lightBoxFileSize: '#B2C2D5',

            // button default - secondary
            buttonBackground: '#FFFFFF',
            buttonBackgroundDisabled: '#FFFFFF',
            buttonBackgroundActive: '#E7ECF1',
            buttonBackgroundFocus: '#FFFFFF',
            buttonBackgroundHover: '#FFFFFF',
            buttonBorder: '#B2C2D5',
            buttonBorderDisabled: '#B2C2D5',
            buttonBorderActive: '#7E95AF',
            buttonBorderHover: '#7E95AF',
            buttomBorderFocus: '#7E95AF',
            buttonIcon: '#7E95AF',
            buttonIconDisabled: '#768FAB',
            buttonIconActive: '#7E95AF',
            buttonIconFocus: '#7E95AF',
            buttonIconHover: '#7E95AF',
            buttonText: '#112337',
            buttonTextFocus: '#112337',
            buttonTextDisabled: '#768FAB',
            buttonTextActive: '#112337',
            buttonTextHover: '#112337',
            buttonOutlineFocus: '#000000',

            // button filled - primary
            buttonFilledBackground: '#112337',
            buttonFilledBackgroundActive: '#38516E',
            buttonFilledBackgroundDisabled: '#B2C2D5',
            buttonFilledBackgroundFocus: '#008AFF',
            buttonFilledBackgroundHover: '#38516E',
            buttonFilledBorder: '#112337',
            buttonFilledBorderActive: '#38516E',
            buttonFilledBorderDisabled: '#B2C2D5',
            buttonFilledBorderFocus: '#008AFF',
            buttonFilledBorderHover: '#38516E',
            buttonFilledIcon: '#B2C2D5',
            buttonFilledIconDisabled: '#E7ECF1',
            buttonFilledIconFocus: '#FFFFFF',
            buttonFilledIconActive: '#889DAE',
            buttonFilledIconHover: '#889DAE',
            buttonFilledText: '#FFFFFF',
            buttonFilledTextDisabled: '#FFFFFF',
            buttonFilledTextActive: '#FFFFFF',
            buttonFilledTextFocus: '#FFFFFF',
            buttonFilledTextHover: '#FFFFFF',
            buttonFilledOutlineFocus: '#008AFF',

            // button text - tertiary
            buttonTextBackground: 'transparent',
            buttonTextBackgroundDisabled: 'transparent',
            buttonTextBackgroundActive: '#e8eaec',
            buttonTextBackgroundFocus: '#e8eaec',
            buttonTextBackgroundHover: '#e8eaec',
            buttonTextBorder: 'transparent',
            buttonTextBorderDisabled: 'transparent',
            buttonTextBorderActive: '#7E95AF',
            buttonTextBorderFocus: '#7E95AF',
            buttonTextBorderHover: '#e8eaec',
            buttonTextIcon: '#7E95AF',
            buttonTextIconDisabled: '#7E95AF',
            buttonTextIconActive: '#7E95AF',
            buttonTextIconFocus: '#7E95AF',
            buttonTextIconHover: '#7E95AF',
            buttonTextContentText: '#112337',
            buttonTextContentTextActive: '#112337',
            buttonTextContentTextFocus: '#112337',
            buttonTextContentTextHover: '#112337',
            buttonTextContentTextDisabled: '#768FAB',
            buttonTextOutlineFocus: '#000000',

            // modal
            modalBackground: '#FFFFFF',
            modalText: '#112337',
            modalBorder: 'transparent',
            modalFooterBackground: '#F6F9FC',
            modalHeaderBackround: '#F6F9FC',
            modalFooterBorder: '#DCE6F2',
            modalIcon: '#89A6C4',
            modalIconError: '$error',
            modalIconSuccess: '$success',
            modalIconWarning: '#EF8B26',
            modalShadow: '#38516E',
            modalShadowOpacity: '#38516E40',

            // input/textarea/select
            inputBackground: '#ffffff',
            inputText: '#112337',
            inputBorder: '#7E95AF',

            inputBackgroundDisabled: '#38516E11',
            inputTextDisabled: '#7E95AF',
            inputBorderDisabled: '#768FAB',

            inputBackgroundHover: '#FFFFFF',
            inputTextHover: '#112337',
            inputBorderHover: '#38516E',

            inputBackgroundActive: '#FFFFFF',
            inputTextActive: '#112337',
            inputBorderActive: '#008AFF',

            inputBackgroundFocus: '#FFFFFF',
            inputTextFocus: '#112337',
            inputBorderFocus: '#38516E',
            inputFocusOutline: '#000000',

            inputBackgroundInvalid: '#FFFFFF',
            inputTextInvalid: '#112337',
            inputBorderInvalid: '#D30000',

            inputBackgroundValid: '#FFFFFF',
            inputTextValid: '#112337',
            inputBorderValid: '#1EB960',

            inputBackgroundAutopopulated: '#ECF6FF',
            inputTextAutopopulated: '#112337',
            inputBorderAutopopulated: '#38516E',

            inputBackgroundAutopopulatedFocus: '#ECF6FF',
            inputTextAutopopulatedFocus: '#112337',
            inputBorderAutopopulatedFocus: '#008AFF',

            inputPlaceholder: '#7E95AF',
            inputIconColor: '#7E95AF',
            inputErrorMessage: '#D30000',
            inputRangeThumbOutlineFocus: '#008AFF',

            // toast
            toastBackgroundDefault: '#008AFF',
            toastTextDefault: '#FFFFFF',
            toastBorderDefault: '#008AFF',

            toastBackgroundSuccess: '#1EB960',
            toastTextSuccess: '#ffffff',
            toastBorderSuccess: '#1EB960',

            toastBackgroundError: '#E84E44',
            toastTextError: '#ffffff',
            toastBorderError: '#E84E44',

            // checkbox
            checkboxBackground: '#ffffff',
            checkboxBackgroundDisabled: '#d5d5d5',
            checkboxBackgroundHover: '#ffffff',
            checkboxBackgroundFocus: '#ffffff',

            checkboxBackgroundChecked: '#38516E',
            checkboxBackgroundCheckedDisabled: '#d5d5d5',
            checkboxBackgroundCheckedHover: '#112337',
            checkboxBackgroundCheckedFocus: '#38516E',

            checkboxBorder: '#B2C2D5',
            checkboxBorderDisabled: '#B2C2D5',
            checkboxBorderHover: '#38516E',
            checkboxBorderFocus: '#B2C2D5',

            checkboxBorderChecked: '#38516E',
            checkboxBorderCheckedDisabled: '#38516E',
            checkboxBorderCheckedHover: '#112337',
            checkboxBorderCheckedFocus: '#38516E',

            checkboxIconChecked: '#FFFFFF',
            checkboxIconCheckedDisabled: '#FFFFFF',
            checkboxIconCheckedHover: '#FFFFFF',
            checkboxIconCheckedFocus: '#FFFFFF',

            checkboxBackgroundHoverChecked: '#112337',
            checkboxDescription: '#7E95AF',
            checkboxFocusOutline: '#000000',

            // switch
            switchBackground: '#FFFFFF',
            switchBackgroundHover: '#112337',
            switchBackgroundFocus: '#FFFFFF',
            switchBackgroundDisabled: '#d5d5d5',

            switchBackgroundChecked: '#38516E',
            switchBackgroundCheckedDisabled: '#38516E',
            switchBackgroundCheckedHover: '#112337',
            switchBackgroundCheckedFocus: '#38516E',

            switchBorder: '#B2C2D5',
            switchBorderHover: '#112337',
            switchBorderFocus: '#B2C2D5',
            switchBorderDisabled: '#B2C2D5',

            switchBorderChecked: '#38516E',
            switchBorderCheckedHover: '#38516E',
            switchBorderCheckedFocus: '#38516E',
            switchBorderCheckedDisabled: '#38516E',

            switchThumbBackground: '#FFFFFF',
            switchThumbBackgroundDisabled: '#ffffff',
            switchThumbBackgroundHover: '#ffffff',
            switchThumbBackgroundFocus: '#ffffff',

            switchThumbBackgroundChecked: '#FFFFFF',
            switchThumbBackgroundCheckedDisabled: '#FFFFFF',
            switchThumbBackgroundCheckedHover: '#FFFFFF',
            switchThumbBackgroundCheckedFocus: '#FFFFFF',

            switchThumbBorder: '#38516E',
            switchThumbBorderDisabled: '#38516E',
            switchThumbBorderHover: '#38516E',
            switchThumbBorderFocus: '#38516E',

            switchThumbBorderChecked: '#38516E',
            switchThumbBorderCheckedDisabled: '#38516E',
            switchThumbBorderCheckedHover: '#38516E',
            switchThumbBorderCheckedFocus: '#38516E',

            switchIcon: '#89A6C4',
            switchIconDisabled: '#89A6C4',
            switchIconHover: '#89A6C4',
            switchIconFocus: '#89A6C4',

            switchIconChecked: '#FFFFFF',
            switchIconCheckedDisabled: '#FFFFFF',
            switchIconCheckedHover: '#FFFFFF',
            switchIconCheckedFocus: '#FFFFFF',

            switchDescription: '#7E95AF',
            switchOutlineFocus: '#000000',

            // chat
            chatBacklogBackground: '#ffffff',
            chatCommandBarWrapper: '#F1F4F8',
            chatCommandBar: '#FFFFFF',
            chatCommandBarBorder: '#E7ECF1',
            chatCommandBarTabBorder: '#E7ECF1',
            chatCommandBarTabText: '#7E95AF',
            chatCommandBarTabSelectedBorder: '#008AFF',
            chatCommandBarTabSelectedText: '#0F243D',
            chatCommandBarTabTextHover: '#131D41',
            chatCommandBarCountBorder: '#B2C2D5',
            chatCommandBarCountText: '#B2C2D5',
            chatCommandBarCannedMessagesBorder: '#2B3641',
            chatCommandBarTextareaText: '#112337',
            chatCommandBarTextareaPlaceholder: '#7E95AF',

            messageInfo: '#F9FBFE',
            messageInfoBorder: '#DCE3EB',
            messageInfoText: '#0F243D',
            messageInfoIcon: '#768FAB',
            messageInfoTimestamp: '#B2C2D5',
            messageInfoLink: '#008AFF',
            messageInfoLinkHover: '#0071D1',

            messageInfoCompact: '#768FAB',
            messageMetadataCompactBackground: '#E7ECF1',

            messageInfoIconError: '$error',
            messageInfoIconSuccess: '$success',
            messageInfoIconWarning: '$warning',

            messageAvatarOperatorModeratorBorder: '#38516E',
            messageAvatarOperatorModeratorText: '#38516E',
            messageAvatarOtherBorder: '#38516E',
            messageAvatarOtherText: '#38516E',
            messageUsernameOperatorModerator: '#112337',
            messageUsernameOther: '#112337',

            messageSpeechBubbleDefault: '#FFFFFF',
            messageSpeechBubbleDefaultBorder: '#DCE3EB',
            messageSpeechBubbleOperatorModerator: '#FFFFFF',
            messageSpeechBubbleOther: '#FFFFFF',
            messageSpeechBubbleOperatorModeratorBorder: '#DCE3EB',
            messageSpeechBubbleOtherBorder: '#DCE3EB',
            messageSpeechBubbleOperatorModeratorText: '#0F243D',
            messageSpeechBubbleOtherText: '#0F243D',
            messageSpeechBubbleOperatorModeratorLink: '#008AFF',
            messageSpeechBubbleOperatorModeratorLinkHover: '#0076D9',
            messageSpeechBubbleOtherLink: '#008AFF',
            messageSpeechBubbleOtherLinkHover: '#0076D9',
            messageSpeechBubbleOperatorModeratorTimestamp: '#B2C2D5',
            messageSpeechBubbleOtherTimestamp: '#B2C2D5',

            messageText: '#0F243D',
            messageDeletedText: '#768FAB',

            cardBackground: '#FFFFFF',
            cardBorder: '#DCE3EB',
            error: '#E84E44',
            errorText: '#FFFFFF',
            headerBackground: '#E4E9EF',
            headerText: '#38516E',
            highlight: '#008AFF',
            hrBorder: '#E7ECF1',
            queueActivityTicketHighlight: '#0076FF',
            smallText: '#7E95AF',
            statusBorder: '#FFFFFF',
            statusClosed: '$error',
            statusConnected: '$success',
            statusIdle: '#FEA043',
            statusOpen: '$success',
            success: '#3CB500',

            timerNormalBackground: '#EFF1F4',
            timerNormalText: '#0F243D',
            timerReminderBackground: '#F8F1D3',
            timerReminderText: '#8B5B00',
            timerWarningBackground: '#F6DBDB',
            timerWarningText: '#790000',

            warning: '#EF8B26',
        },
        borderWidths: {
            button: '1px',
            buttonFilled: '1px',
            buttonText: '1px',
            modal: '1px',
            input: '1px',
            toast: '0px',
            checkbox: '1px',
            switch: '1px',
            switchThumb: '1px',
            chatCommandBar: '1px',
            messageInfo: '1px',
            messageSpeechBubbleDefault: '1px',
            messageSpeechBubbleOther: '1px',
            messageSpeechBubbleOperatorModerator: '1px',
        },
        borderStyles: {
            button: 'solid',
            buttonFilled: 'solid',
            buttonText: 'solid',
            modal: 'solid',
            input: 'solid',
            toast: 'solid',
            checkbox: 'solid',
            switch: 'solid',
            switchThumb: 'solid',
            chatCommandBar: 'solid',
            messageInfo: 'solid',
            messageSpeechBubbleDefault: 'solid',
            messageSpeechBubbleOther: 'solid',
            messageSpeechBubbleOperatorModerator: 'solid',
        },
        fontWeights: {
            button: '400',
            buttonFilled: '400',
            buttonText: '400',
            labelText: '600',
            legendText: 'bold',
            modalHeaderText: '600',
            modal: '400',
            input: '400',
            toast: '400',
            messageInfoText: '400',
            messageUsernameOperatorModerator: 'bold',
            messageUsernameOther: 'bold',

            messageSpeechBubbleOther: '400',
            messageSpeechBubbleOperatorModerator: '400',
        },
        fontSizes: {
            button: '14px',
            buttonFilled: '14px',
            buttonText: '14px',
            modal: '16px',
            input: '15px',
            toast: '14px',
            messageInfoText: '15px',
            messageUsernameOperatorModerator: '14px',
            messageUsernameOther: '14px',
            messageSpeechBubbleOther: '14px',
            messageSpeechBubbleOperatorModerator: '14px',
        },
        fontStyle: {
            button: 'normal',
            buttonFilled: 'normal',
            buttonText: 'normal',
            modal: 'normal',
            input: 'normal',
            toast: 'normal',
            messageInfoText: 'normal',
            messageUsernameOperatorModerator: 'normal',
            messageUsernameOther: 'normal',

            messageSpeechBubbleOther: 'normal',
            messageSpeechBubbleOperatorModerator: 'normal',
        },
        fontVariant: {
            button: 'normal',
            buttonFilled: 'normal',
            buttonText: 'normal',
            modal: 'normal',
            input: 'normal',
            toast: 'normal',
            messageInfoText: 'normal',
            messageUsernameOperatorModerator: 'normal',
            messageUsernameOther: 'normal',

            messageSpeechBubbleOther: 'normal',
            messageSpeechBubbleOperatorModerator: 'normal',
        },
        fonts: {
            button: 'inherit',
            buttonFilled: 'inherit',
            buttonText: 'inherit',
            defaultText: '\'Open Sans\', sans-serif',
            modal: 'inherit',
            input: 'inherit',
            toast: 'inherit',
            messageInfoText: 'inherit',
            messageUsernameOperatorModerator: 'inherit',
            messageUsernameOther: 'inherit',
            messageSpeechBubbleOther: 'inherit',
            messageSpeechBubbleOperatorModerator: 'inherit',
        },
        radii: {
            button: '6px',
            buttonFilled: '6px',
            buttonText: '6px',
            modal: '10px',
            input: '6px',
            toast: '6px',
            checkbox: '6px',
            switch: '6px',
            switchThumb: '3px',
            chatCommandBar: '6px',
            messageInfo: '10px',
            messageSpeechBubbleDefault: '10px',
            messageSpeechBubbleDefaultCorner: '6px',
            messageSpeechBubbleOther: '10px',
            messageSpeechBubbleOperatorModerator: '10px',
        },
        sizes: {
            buttonIcon: '20px',
            buttonIconSmall: '18px',
        },
        space: {
            buttonPaddingHorizontal: '8px',
            buttonPaddingHorizontalLarge: '11px',
            buttonPaddingHorizontalSmall: '6px',
            buttonPaddingVertical: '5px',
            buttonPaddingVerticalLarge: '10px',
            buttonPaddingVerticalSmall: '4px',
            buttonTextMargin: '10px',
            inputPaddingHorizontal: '8px',
            inputPaddingVertical: '6px',
        },
        lineHeights: {
            button: 'normal',
            buttonFilled: 'normal',
            buttonText: 'normal',
            modal: 'normal',
            input: 'normal',
            toast: 'normal',
            messageInfoText: 'normal',
            messageUsernameOperatorModerator: 'normal',
            messageUsernameOther: 'normal',

            messageSpeechBubbleOther: 'normal',
            messageSpeechBubbleOperatorModerator: 'normal',
        },
        shadows: {
            chatCommandBarTabContainer: 'inset 0px -1px 0px 0px #E7ECF1',
            chatCommandBarTabFocus: 'inset 0px 0px 0px 2px #000000',
        },
    },
}

export const defaults = {
    theme: {
        ...shared.theme,
        backgroundSizes: {},
        borderStyles: {...shared.theme.borderStyles},
        borderWidths: {
            ...shared.theme.borderWidths,
            alert: '1px',
            avatar: '2px',
            avatarStatus: '1px',
            card: '1px',
        },
        colors: {
            ...shared.theme.colors,
            accountSettingsCardHeaderBorder: '#E4EAF0',
            accountSettingsIcon: '#768FAB',
            accountSettingsLightText: '#38516E',

            alertBackgroundError: '#F0DADD',
            alertBorderError: '#E84E44',
            alertIconError: '#E84E44',
            alertBackgroundInfo: '#DFF0FF',
            alertBorderInfo: '#78C1FF',
            alertIconInfo: '#008AFF',
            alertBackgroundSuccess: '#D6EBD3',
            alertBorderSuccess: '#3CB500',
            alertIconSuccess: '#3CB500',
            alertBackgroundWarning: '#F1E5D8',
            alertBorderWarning: '#EF8B26',
            alertIconWarning: '#EF8B26',

            assignQueuesLightText: '#7E95AF',
            audienceCommentChangeText: '#38516E',
            audienceCommentText: '#112337',
            audienceCommentTimestamp: '#768FAB',
            audienceCommentUserName: '#112337',
            avatarBackgroundHighlight: '#008AFF',
            avatarBackgroundUnread: '#38516E',
            avatarBorderHighlight: '#008AFF',
            avatarBorderUnread: '#38516E',
            avatarTextHighlight: '#FFFFFF',
            avatarTextUnread: '#FFFFFF',
            boostAgentText: '#59708A',
            boostButtonBorder: '#B2C2D5',
            boostVisitorText: '#0F243D',
            breadcrumbText: '#7E95AF',
            cannedMessageBackgroundFocus: '#F1F6F9',
            cannedMessageBackgroundHover: '#38516E11',
            cannedMessageKeywordText: '#496280',
            cannedMessageSharedText: '#7F95AF',
            cannedMessageText: '#38516E',
            channelSidebarBackground: '#FFFFFF',
            channelSidebarBorder: '#E7ECF1',
            confirmation: '#F9FBFE',
            confirmationBorder: '#DCE3EB',
            datePickerActive: '#FFFFFF',
            datePickerActiveBackground: '#38516E',
            datePickerArrow: '#38516E',
            datePickerBorder: '#E7ECF1',
            datePickerCalendar: '#FFFFFF',
            datePickerFooter: '#F6F9FC',
            datePickerPopup: '#FFFFFF',
            datePickerSelected: '#38516E11',
            datePickerText: '#0F243D',
            datePickerWeekend: '#d10000',
            dropdownBackground: '#FFFFFF',
            dropdownBorder: '#DCE6F2',
            dropdownButtonIconDisabled: '#768FAB',
            dropdownHrBorder: '#DCE6F2',
            dropdownShadow: '#38516E4D',
            formDescriptionText: '#38516E',
            hrBorder: '#354451',
            hrBorderLight: '#DCE3EB',
            icon: '#7E95AF',
            loginBorder: '#DCE3EB',
            loginInfoIcon: '#7E95AF',
            loginLightText: '#38516E',
            loginSelectedBorder: '#008AFF',
            loginTabNotSelected: '#112337',
            loginTabSelected: '#38516E',
            logo: '#0F243D',
            mainBackground: '#F1F4F8',
            menubarBorder: '#E7ECF1',
            menubarHeaderText: '#38516E',
            messageInfoPrivileged: '#768FAB',
            messageInvitationHighlighted: '#F9FBFE',
            messageInvitationLightText: '#768FAB',
            metadataBackground: '$messageSpeechBubbleDefault',
            metadataBorder: '$messageSpeechBubbleDefaultBorder',
            metadataHeaderBackground: '#F9FBFE',
            metadataIconNinchat: '#78AE15',
            metadataIconSecure: '#7E95AF',
            metadataItemBackgroundHover: '#E7ECF1',
            metadataKey: '#768FAB',
            metadataHeaderText: 'inherit',
            modalBorder: '#DCE3EB',
            modalChannelInvitationBorder: '#E7ECF1',
            modalOverlay: '#00000054',
            modalTranscriptBackground: '#F1F4F8',
            modalTranscriptBorder: '#DCE3EB',
            modalTranscriptText: '#38516E',
            needHelpButton: '#0071D1',
            organizationNameLightText: '#768FAB',
            paginationNotSelectedHover: '#38516E11',
            paginationOutline: '#000000',
            paginationSelected: '#112337',
            paginationSelectedHover: '#38516E',
            paginationSelectedText: '#FFFFFF',
            questionnaireAnswersBackground: '$messageSpeechBubbleDefault',
            questionnaireAnswersBorder: '$messageSpeechBubbleDefaultBorder',
            queueFeatureBorder: '#B2C2D5',
            queueIcon: '#38516E',
            queueIconOpen: '$success',
            radioButtonBackground: '$inputBackground',
            radioButtonBackgroundChecked: '$inputBackground',
            radioButtonBackgroundHoverChecked: '#E7ECF1',
            radioButtonBorder: '#B2C2D5',
            radioButtonBorderChecked: '#38516E',
            radioButtonBorderCheckedHover: '#38516E',
            radioButtonBorderHover: '#38516E',
            radioButtonDotColor: '#38516E',
            radioButtonDotColorHover: '#38516E',
            radioButtonFocusOutline: '#000000',
            resultsTableTextLighter: '#768FAB',
            scheduleLegendText: '#38516E',
            searchAutocompleteBorder: '#112337',
            searchAutocompleteResultHighlighted: '#E7ECF1',
            searchAutocompleteResultOdd: '#F9FBFE',
            searchAutocompleteResults: '#FFFFFF',
            searchAutocompleteResultsBoxShadow: '#00000033',
            searchAutocompleteText: '#112337',
            searchAutocompleteTextLighter: '#768FAB',
            sidebarButtonBackground: 'transparent',
            sidebarButtonBackgroundActive: '#ECF4F9',
            sidebarButtonBackgroundHover: '#38516E11',
            sidebarButtonText: '#38516E',
            sidebarLabelText: '#88A0BB',
            sidebarNestedBorder: '#DCE6F2',
            sidebarQueueingTimeText: '#88A0BB',
            sidebarStatusIcon: '#768FAB',
            sidebarStatusIconActive: '#E84E44',
            tableBackground: '#FFFFFF',
            tableBackgroundHover: '#E7ECF1',
            tableBorder: '#DCE3EB',
            tableCellStatusNegative: '#E84E44',
            tableCellStatusNeutral: '#7E95AF',
            tableCellStatusPositive: '#3CB500',
            tableHeaderBackground: '#F9FBFE',
            tableHeaderRowsSelected: '#38516E',
            tableHeaderRowsSelectedBackground: '#E7ECF1',
            tableHeaderText: '#59708A',
            tableLoader: '#E7ECF1',
            tableLoaderSlider: '#EFF4F9',
            tableRowBackgroundEven: '#F9FBFE',
            tableText: '#38516E',
            tagBackground: 'transparent',
            tagBackgroundSelected: '#38516E',
            tagBorder: '#B2C2D5',
            tagBorderSelected: '#38516E',
            tagDefault: '#049cdb',
            tagIcon: '#B4C2D2',
            tagText: '#112337',
            tagTextSelected: '#FFFFFF',
            tagsCloseButtonHover: '#0089E5',
            timelineInputTrackBackground: '#38516E',
            timelineInputTrackBackgroundHover: '#B2C2D5',
            timelineNumbersText: '#DCE3EB',
            timelineSliderThumb: '#38516E',
            timelineSliderThumbBackground: '#FFFFFF',
            timelineSliderThumbBackgroundHover: '#E7ECF1',
            timelineSliderThumbBorder: '#38516E',
            timelineTrackBackground: '#DCE3EB',
            timelineTrackBackgroundHover: '#B2C2D5',
            timepickerIcon: '#768FAB',
            timezoneIcon: '#768FAB',
            toggleBorder: '#E4EAF0',
            toggleButtonText: '#131D41',
            toggleIcon: '#768FAB',
            tooltip: '#000000',
            tooltipText: '#FFFFFF',
            userInfoBadge: '#E7ECF1',
            userInfoBadgeBackground: '#7E95AF',
            userInfoInfoText: '#7E95AF',
            userInfoText: '#0F243D',
            userNameText: '#112337',
            wordList: '$inputBackground',
            wordListBorder: '#B2C2D5',
            wordListBorderFocus: '#38516E',
            wordListBorderHover: '#7E95AF',
            wordListItem: '#BBC9D9',
            wordListItemIcon: '#7E95AF',
            wordListItemIconHover: '#112337',
            wordListItemText: '#112337',
        },
        fontSizes: {
            ...shared.theme.fontSizes,
            accountSettingsSubheading: '16px',
            assignQueuesSmall: '13px',
            audienceCommentText: '14px',
            audienceCommentTimestamp: '12px',
            avatarBigText: '80px',
            avatarMidText: '47px',
            avatarSmallText: '13px',
            avatarText: '15px',
            captionText: '14px',
            errorFontSize: '12px',
            formDescriptionText: '15px',
            labelText: '14px',
            legendText: '16px',
            loginTooltipText: '13px',
            masterKeysSettingsSubheading: '16px',
            menubarHeaderText: '15px',
            messageInfoPrivileged: '13px',
            messageInvitationChannel: '15px',
            messageInvitationRealm: '13px',
            messageText: '15px',
            messageTimestamp: '11px',
            metadataHeaderText: '14px',
            modalChannelInvitationTooltip: '12px',
            modalHeaderText: '18px',
            modalTranscriptHeader: '15px',
            needHelpButton: '15px',
            scheduleLegendText: '15px',
            searchAutocompleteResultItemText: '14px',
            searchAutocompleterResultsHeaderText: '13px',
            sidebarButtonText: '13px',
            sidebarQueueingTimeText: '13px',
            sidebarTicketText: '13px',
            smallText: '13px',
            table: '14px',
            tableHeader: '13px',
            tableSearch: '14px',
            tableSortButton: '15px',
            tagText: '14px',
            timepickerItem: '14px',
            toggleButton: '15px',
            toggleButtonSmall: '13px',
            tooltip: '13px',
            userNameText: '14px',
            lightBoxFileSize: '12px',
        },
        fontStyle: {...shared.theme.fontStyle},
        fontVariant: {...shared.theme.fontVariant},
        fontWeights: {
            ...shared.theme.fontWeights,
            captionText: 'bold',
            menubarHeaderText: 'bold',
            metadataHeaderText: 'bold',
            sidebarTicketText: 'bold',
            tableHeader: 600,
            userNameText: 400,
        },
        fonts: {
            ...shared.theme.fonts,
            defaultText: '\'Open Sans\', sans-serif',
        },
        lineHeights: {...shared.theme.lineHeights},
        radii: {
            ...shared.theme.radii,
            alertBorder: '6px',
            avatarBigBorder: '50px',
            avatarBorder: '14px',
            avatarMidBorder: '34px',
            avatarSmallBorder: '10px',
            avatarStatus: '6px',
            cardBorder: '6px',
            datePicker: '5px',
            dropdownBorder: '4px',
            errorBorder: '0.2rem',
            messageInvitationHighlighted: '4px',
            metadataBorder: '$messageSpeechBubbleDefaultBorder',
            metadataItemBorder: '$buttonBorder',
            pipBorder: '0.4rem',
            questionnaireAnswersBorder: '$messageSpeechBubbleDefault',
            searchAutocompleteBorder: '6px',
            sidebarButtonBorder: '$buttonBorder',
            tableBorder: '6px',
            tableLoader: '3px',
            tableSelectedBorder: '6px',
            tagBorder: '0.2rem',
            timepickerItem: '4px',

        },
        sizes: {
            ...shared.theme.sizes,
            accountSettingsCardHeaderIcon: '26px',
            alertIcon: '20px',
            avatar: '30px',
            avatarBig: '120px',
            avatarMid: '80px',
            avatarSmall: '24px',
            avatarStatus: '10px',
            captionIcon: '20px',
            channelSidebarWidth: '408px',
            chatWidth: '380px',
            menubarHeight: '50px',
            messageInfoIcon: '20px',
            metadataHeaderIcon: '20px',
            sidebarWidth: '300px',
            toggleIcon: '20px',
        },
        maxWidths: {userNameMaxWidth: '240px'},
        space: {
            ...shared.theme.space,
            accountSettingsCardHeaderContentPaddingHorizonal: '6px',
            accountSettingsCardHeaderContentPaddingVertical: '24px',
            accountSettingsCardHeaderIconMargin: '10px',
            accountSettingsCardHeaderMargin: '10px',
            accountSettingsCardPaddingVertical: '16px',
            accountSettingsIconGap: '5px',
            accountSettingsIdentitiesGap: '10px',
            accountSettingsIdentitiesWrapperMarginVertical: '20px',
            alertItemsGap: '10px',
            alertPaddingHorizontal: '20px',
            alertPaddingVertical: '20px',
            avatarMarginHorizontal: '10px',
            captionIconMargin: '10px',
            channelInviteItemContainerPaddingVertical: '20px',
            channelInviteItemPaddingVertical: '5px',
            channelSidebarPadding: '1rem',
            datePickerNavigationPaddingVertical: '5px',
            datePickerPaddingVertical: '5px',
            datePickerPopupPadding: '15px',
            datePickerTileMarginVertical: '3px',
            datePickerTilePadding: '8px',
            dropdownMargin: '5px',
            errorMargin: '20px',
            errorTextMargin: '30px',
            formDescriptionMargin: '16px',
            formPadding: '20px',
            legendTextMargin: '10px',
            menubarPaddingHorizontal: '12px',
            menubarPaddingVertical: '0px',
            messageInfoIconGap: '10px',
            messageInvitationChannelNameVertical: '10px',
            messageInvitationHighlightedPadding: '8px',
            messageInvitationHighlightedVertical: '10px',
            messageInvitationInfoButtonVertical: '5px',
            messageInvitationTextVertical: '10px',
            messageSpeechBubblePaddingHorizontal: '10px',
            messageSpeechBubblePaddingVertical: '5px',
            metadataHeaderIconMargin: '10px',
            metadataItemPaddingHorizontal: '6px',
            metadataItemPaddingVertical: '2px',
            metadataPaddingHorizontal: '10px',
            metadataPaddingVertical: '10px',
            modalChannelInvitationPaddingVertical: '10px',
            modalChannelInvitationPaddingVerticalLarge: '20px',
            modalHeaderTextMargin: '10px',
            modalPaddingHorizontal: '20px',
            modalPaddingVertical: '18px',
            questionnaireAnswersPaddingHorizontal: '10px',
            questionnaireAnswersPaddingVertical: '10px',
            resultsTableCellPaddingHorizontal: '15px',
            resultsTableCellPaddingVertical: '15px',
            scheduleLegendTextMargin: '6px',
            searchAutocompleWrapperVertical: '10px',
            searchAutocompleteNoResultsHorizontal: '15px',
            searchAutocompleteNoResultsVertical: '10px',
            searchAutocompleteResultHorizontal: '15px',
            searchAutocompleteResultVertical: '10px',
            searchAutocompleteResultTemplateChildHorizontal: '15px',
            searchAutocompleteResultsHeaderHorizontal: '15px',
            searchAutocompleteResultsHeaderVertical: '10px',
            searchAutocompleteResultsVertical: '20px',
            sidebarButtonMargingHorizontal: '10px',
            sidebarButtonPadding: '5px',
            sidebarPadding: '8px',
            sidebarQueueingTimeMarginHorizontal: '3px',
            sidebarStatusMarginHorizontal: '4px',
            sidebarTicketMarginHorizontal: '4px',
            sidebarTicketTextMarginHorizontal: '3px',
            tableFooterPaddingVertical: '10px',
            tableHeaderPaddingHorizontal: '14px',
            tableHeaderPaddingVertical: '8px',
            tableHeaderRowsSelectedPaddingHorizontal: '12px',
            tableHeaderRowsSelectedPaddingVertical: '6px',
            tablePaddingHorizontal: '14px',
            tablePaddingVertical: '6px',
            tableSearchPaddingHorizontal: '10px',
            tableSearchPaddingVertical: '5px',
            tagPaddingHorizontal: '0.6rem',
            tagPaddingVertical: '0.3rem',
            toggleButtonPaddingVertical: '10px',
            toggleContentPaddingVertical: '10px',
            toggleIconMarginHorizonal: '5px',
            toggleMarginVertical: '10px',
            tooltipHorizontal: '12px',
            tooltipVertical: '8px',

        },
        zIndices: {
            // LAYER 0: Base (1-10) - Internal component stacking
            base: 1,

            // LAYER 1: UI Components (20-50) - Sidebars, tooltips, pickers
            fileThumbnailOverlay: 10,
            needHelpButton: 20,
            colorPickerOverlay: 25,
            searchAutocompleteResults: 30,
            sideMenu: 35,
            tooltip: 40,
            datePicker: 45,
            colorPicker: 46,

            // LAYER 2: Overlays & Video (100-109) - Video, permission screens
            permissionDeniedOverlay: 100,
            jitsi: 105,
            jitsiPip: 107,
            chatOnJitsi: 108, // Above jitsi but below modal

            // LAYER 3: Modals & Dropdowns (110-150) - All modals above video
            modal: 110,
            dropdown: 115,
            dropdownNestedMenu: 116,

            // LAYER 4: High Priority Modals (200-500)
            modalHighPriority: 200,
            lightBox: 210, // only toast are higher or some custom modals which pass zIndex directly

            // LAYER 5: Critical (1000+)
            toast: 1000,
        },
    },
}

export const compact = {
    colors: {
        messageInfo: 'transparent',
        messageSpeechBubbleDefault: 'transparent',
        messageSpeechBubbleOther: 'transparent',
        messageSpeechBubbleOperatorModerator: 'transparent',
        messageSpeechBubbleOtherBorder: 'transparent',
        messageSpeechBubbleOperatorModeratorBorder: 'transparent',
        messageSpeechBubbleBorder: 'transparent',
    },
    fontSizes: {messageText: '14px'},
    space: {
        messageSpeechBubblePaddingHorizontal: '0',
        messageSpeechBubblePaddingVertical: '0',
    },
}

export const dark = {
    ...defaults.theme,
    colors: {
        ...defaults.theme.colors,
        accountSettingsCardHeaderBorder: '#354451',
        accountSettingsIcon: '#768FAB',
        accountSettingsLightText: '#5F7282',

        attachmentFileBorder: '#5F7282',
        attachmentFileHoverBackground: '#354451',
        attachmentFileDownloadLinkHover: '#252F38',

        alertBackgroundError: '#382528',
        alertBackgroundInfo: '#273744',
        alertBackgroundSuccess: '#1E351E',
        alertBackgroundWarning: '#392F23',

        audienceCommentChangeText: '#9AAEC8',
        audienceCommentText: '#D0DCEB',
        audienceCommentTimestamp: '#7E95AF',
        audienceCommentUserName: '#D0DCEB',

        avatarBorder: '#AFC0D4',
        avatarText: '#AFC0D4',
        boostAgentText: '#7089A3',
        boostVisitorText: '#FFFFFF',

        // button default - secondary
        buttonBackground: '#252F38',
        buttonBackgroundActive: '#354451',
        buttonBorder: '#5F7282',
        buttonBorderHover: '#AFC0D4',
        buttonIcon: '#889DAE',
        buttonIconDisabled: '#455665',
        buttonOutlineFocus: '#D0DCEB',
        buttonText: '#D0DCEB',
        buttonBackgroundDisabled: '#252F38',
        buttonBackgroundFocus: '#354451',
        buttonBackgroundHover: '#354451',
        buttonBorderDisabled: '#5F7282',
        buttonBorderActive: '#5F7282',
        buttomBorderFocus: '#5F7282',
        buttonIconActive: '#889DAE',
        buttonIconFocus: '#889DAE',
        buttonIconHover: '#889DAE',
        buttonTextFocus: '#D0DCEB',
        buttonTextDisabled: '#D0DCEB',
        buttonTextActive: '#D0DCEB',
        buttonTextHover: '#D0DCEB',

        // button filled - primary
        buttonFilledBackground: '#D0DCEB',
        buttonFilledBackgroundActive: '#E1E9F3',
        buttonFilledBackgroundDisabled: '#354451',
        buttonFilledBackgroundFocus: '#008AFF',
        buttonFilledBackgroundHover: '#E1E9F3',
        buttonFilledBorder: '$buttonFilledBackground',
        buttonFilledBorderActive: '$buttonFilledBackgroundActive',
        buttonFilledBorderDisabled: '$buttonFilledBackgroundDisabled',
        buttonFilledBorderFocus: '$buttonFilledBackgroundFocus',
        buttonFilledBorderHover: '$buttonFilledBackgroundHover',
        buttonFilledIcon: '#889DAE',
        buttonFilledIconDisabled: '#5F7282',
        buttonFilledIconFocus: '#FFFFFF',
        buttonFilledOutlineFocus: '$buttonFilledBackgroundFocus',
        buttonFilledText: '#131D41',
        buttonFilledTextDisabled: '#5F7282',
        buttonFilledIconActive: '#FFFFFF',
        buttonFilledIconHover: '#FFFFFF',
        buttonFilledTextActive: '#131D41',
        buttonFilledTextFocus: '#131D41',
        buttonFilledTextHover: '#131D41',

        // button text - tertiary
        buttonTextBackgroundFocus: '#354451',
        buttonTextBackgroundHover: '#252F38',

        buttonTextBackground: 'transparent',
        buttonTextBackgroundDisabled: 'transparent',
        buttonTextBackgroundActive: '#354451',
        buttonTextBorder: 'transparent',
        buttonTextBorderDisabled: 'transparent',
        buttonTextBorderActive: '#5F7282',
        buttonTextBorderFocus: '#5F7282',
        buttonTextBorderHover: 'transparent',
        buttonTextIcon: '#889DAE',
        buttonTextIconDisabled: '#889DAE',
        buttonTextIconActive: '#889DAE',
        buttonTextIconFocus: '#889DAE',
        buttonTextIconHover: '#889DAE',
        buttonTextContentText: '#D0DCEB',
        buttonTextContentTextActive: '#D0DCEB',
        buttonTextContentTextFocus: '#D0DCEB',
        buttonTextContentTextHover: '#D0DCEB',
        buttonTextContentTextDisabled: '#D0DCEB',
        buttonTextOutlineFocus: '#D0DCEB',

        // canned messages
        cannedMessageBackgroundFocus: '#252F38',
        cannedMessageBackgroundHover: '#303E4B',
        cannedMessageKeywordText: '#7E95AF',
        cannedMessageSharedText: '#6A7E95',
        cannedMessageText: '#A9B4C1',

        // card
        cardBackground: '#252F38',
        cardBorder: '#354451',

        channelSidebarBackground: '#1A2026',
        channelSidebarBorder: '#2B3641',

        // checkbox
        checkboxBackground: '#252F38',
        checkboxBackgroundDisabled: '#d5d5d5',
        checkboxBackgroundHover: '#252F38',
        checkboxBackgroundFocus: '#252F38',

        checkboxBackgroundChecked: '#AFC0D4',
        checkboxBackgroundCheckedDisabled: '#d5d5d5',
        checkboxBackgroundCheckedHover: '#AFC0D4',
        checkboxBackgroundCheckedFocus: '#AFC0D4',

        checkboxBorder: '#5F7282',
        checkboxBorderDisabled: '#B2C2D5',
        checkboxBorderHover: '#AFC0D4',
        checkboxBorderFocus: '#AFC0D4',

        checkboxBorderChecked: '#5F7282',
        checkboxBorderCheckedDisabled: '#B2C2D5',
        checkboxBorderCheckedHover: '#AFC0D4',
        checkboxBorderCheckedFocus: '#AFC0D4',

        checkboxIconChecked: '#FFFFFF',
        checkboxIconCheckedDisabled: '#FFFFFF',
        checkboxIconCheckedHover: '#FFFFFF',
        checkboxIconCheckedFocus: '#FFFFFF',

        checkboxBackgroundHoverChecked: '#D0DCEB',
        checkboxDescription: '#AFC0D4',
        checkboxFocusOutline: '#5F7282',
        checkboxIcon: '#112337',

        // confirmation
        confirmation: '#252F38',
        confirmationBorder: '#354451',

        // chat
        chatBacklogBackground: '#191E24',
        chatCommandBarWrapper: 'transparent',
        chatCommandBar: '#252F38',
        chatCommandBarBorder: '#2B3641',
        chatCommandBarTabBorder: '#2B3641',
        chatCommandBarTabText: '#B2C2D5',
        chatCommandBarTabSelectedBorder: '#008AFF',
        chatCommandBarTabSelectedText: '#B2C2D5',
        chatCommandBarCountBorder: '#B2C2D5',
        chatCommandBarCountText: '#B2C2D5',
        chatCommandBarTabTextHover: '#D0DCEB',
        chatCommandBarCannedMessagesBorder: '#354451',
        chatCommandBarTextareaText: '#D0DCEB',
        chatCommandBarTextareaPlaceholder: '#5F7282',

        messageSpeechBubbleOther: '#252F38',
        messageSpeechBubbleOperatorModerator: '#252F38',
        messageSpeechBubbleOtherBorder: '#354451',
        messageSpeechBubbleOperatorModeratorBorder: '#252F38',
        messageSpeechBubbleDefault: '#252F38',
        messageSpeechBubbleDefaultBorder: '#354451',

        messageInfo: '#252F38',
        messageInfoBorder: '#354451',
        messageInvitationHighlighted: '#252F38',
        messageInvitationLightText: '#AFC0D4',
        messageText: '#AFC0D4',
        messageTimestamp: '#AFC0D4',
        messageUsernameOther: '#AFC0D4',

        messageInfoText: '#AFC0D4',
        messageDeletedText: '#768FAB',
        messageInfoIcon: '#6986A8',
        messageInfoTimestamp: '#6784A6',
        messageInfoLink: '#008AFF',
        messageInfoLinkHover: '#0071D1',
        messageInfoIconError: '$error',
        messageInfoIconSuccess: '$success',
        messageInfoIconWarning: '$warning',

        messageAvatarOperatorModeratorBorder: '#354451',
        messageAvatarOperatorModeratorText: '#AFC0D4',
        messageAvatarOtherBorder: '#354451',
        messageAvatarOtherText: '#AFC0D4',
        messageUsernameOperatorModerator: '#AFC0D4',
        messageSpeechBubbleOperatorModeratorText: '#AFC0D4',
        messageSpeechBubbleOtherText: '#AFC0D4',
        messageSpeechBubbleOperatorModeratorLink: '#008AFF',
        messageSpeechBubbleOperatorModeratorLinkHover: '#0076D9',
        messageSpeechBubbleOtherLink: '#008AFF',
        messageSpeechBubbleOtherLinkHover: '#0076D9',
        messageSpeechBubbleOperatorModeratorTimestamp: '#6784A6',
        messageSpeechBubbleOtherTimestamp: '#6784A6',

        // datepicker
        datePickerActive: '#131D41',
        datePickerActiveBackground: '#D0DCEB',
        datePickerArrow: '#D0DCEB',
        datePickerBorder: '#354451',
        datePickerCalendar: '#252F38',
        datePickerFooter: '#2C3944',
        datePickerPopup: '#252F38',
        datePickerSelected: '#354451',
        datePickerText: '#D0DCEB',

        dropdownBackground: '#384652',
        dropdownBorder: '#354451',
        dropdownButtonIconDisabled: '#5F7282',
        dropdownHrBorder: '#4C5964',
        headerBackground: '#252F38',
        headerText: '#AFC0D4',
        hrBorderLight: '#2B3641',

        // input
        inputBackground: '#252F38',
        inputBorder: '#354451',
        inputBorderFocus: '#AFC0D4',
        inputBorderHover: '#889DAE',
        inputText: '#D0DCEB',
        inputPlaceholder: '#5F7282',
        inputBackgroundDisabled: '#252F38',
        inputTextDisabled: '#768FAB',
        inputBorderDisabled: '#354451',
        inputBackgroundHover: '#252F38',
        inputTextHover: '#D0DCEB',
        inputBackgroundActive: '#252F38',
        inputTextActive: '#D0DCEB',
        inputBorderActive: '#AFC0D4',
        inputBackgroundFocus: '#252F38',
        inputTextFocus: '#D0DCEB',
        inputFocusOutline: '#D0DCEB',
        inputBackgroundInvalid: '#252F38',
        inputTextInvalid: '#D0DCEB',
        inputBackgroundValid: '#252F38',
        inputTextValid: '#D0DCEB',
        inputBackgroundAutopopulated: '#252F38',
        inputTextAutopopulated: '#D0DCEB',
        inputBorderAutopopulated: '#354451',
        inputBackgroundAutopopulatedFocus: '#AFC0D4',
        inputTextAutopopulatedFocus: '#D0DCEB',
        inputBorderAutopopulatedFocus: '#AFC0D4',
        inputIconColor: '#AFC0D4',
        inputRangeThumbOutlineFocus: '#D0DCEB',

        // login
        loginBorder: '#354451',
        loginInfoIcon: '#7E95AF',
        loginLightText: '#889DAE',
        loginSelectedBorder: '#008AFF',
        loginTabNotSelected: '#A9B4C1',
        loginTabSelected: '#5F7282',

        logo: '#FFFFFF',
        mainBackground: '#191E23',
        menubarBorder: '#2B3641',
        menubarHeaderText: '#AFC0D4',

        metadataBorder: 'transparent',
        metadataHeaderBackground: '#2C3944',
        metadataItemBackgroundHover: '#303E4B',
        metadataItemBorder: '$metadataItemBackgroundHover',
        metadataSectionBorder: '#394753',

        // modal
        modalBackground: '#252F38',
        modalBorder: '#354451',
        modalChannelInvitationBorder: '#354451',
        modalFooterBackground: '#2C3944',
        modalHeaderBackground: '#2C3944',
        modalFooterBorder: '#354451',
        modalIcon: '#6986A8',
        modalOverlay: '#FFFFFF1A',
        modalShadow: 'transparent',
        modalShadowOpacity: 'transparent',
        modalTranscriptBackground: '#1A2026',
        modalTranscriptBorder: '#354451',
        modalTranscriptText: '#A9B4C1',
        modalText: '#AFC0D4',

        // pagination
        paginationNotSelectedHover: '#354451',
        paginationOutline: '#D0DCEB',
        paginationSelected: '#354451',
        paginationSelectedHover: '#38516E',
        paginationSelectedText: '#FFFFFF',

        queueIcon: '#AFC0D4',

        // radio
        radioButtonBackground: '#252F38',
        radioButtonBackgroundChecked: '$radioButtonBackground',
        radioButtonBackgroundHoverChecked: '$radioButtonBackground',
        radioButtonBorder: '#5F7282',
        radioButtonBorderChecked: '#AFC0D4',
        radioButtonBorderCheckedHover: '#D0DCEB',
        radioButtonBorderHover: '#AFC0D4',
        radioButtonDotColor: '#AFC0D4',
        radioButtonDotColorHover: '#D0DCEB',
        radioButtonFocusOutline: '#5F7282',

        scheduleLegendText: '#A9B4C1',

        // autocomplete
        searchAutocompleteBorder: '#AFC0D4',
        searchAutocompleteResultHighlighted: '#354451',
        searchAutocompleteResultOdd: '#29343E',
        searchAutocompleteResults: '#252F38',
        searchAutocompleteResultsBoxShadow: 'transparent',

        searchAutocompleteText: '#D0DCEB',
        searchAutocompleteTextLighter: '#889DAE',

        sidebarButtonBackgroundActive: '#384652',
        sidebarButtonBackgroundHover: '#252F38',
        sidebarButtonText: '#AFC0D4',
        sidebarNestedBorder: '#354451',
        statusBorder: '#1B2127',

        // switch
        switchBackground: '#252F38',
        switchBackgroundChecked: '#354451',
        switchBackgroundHover: '#354451',
        switchBorder: '#354451',
        switchBorderChecked: '#354451',
        switchBorderHover: '#354451',
        switchOutlineFocus: '#354451',
        switchThumb: '#252F38',
        switchThumbBorder: '#AFC0D4',
        switchThumbChecked: '#FFFFFF',

        // table
        tableBackground: '#252F38',
        tableBackgroundHover: '#303E4B',
        tableBorder: '#354451',
        tableHeaderBackground: '#29343E',
        tableHeaderRowsSelected: '#D0DCEB',
        tableHeaderRowsSelectedBackground: '#354451',
        tableHeaderText: '#D0DCEB',
        tableLoader: '#354451',
        tableLoaderSlider: '#1F252C',
        tableRowBackgroundEven: '#29343E',
        tableText: '#D0DCEB',

        // tag
        tagBorder: '#364D6A',
        tagIcon: '#B4C2D2',
        tagText: '#D0DCEB',

        // toggle
        toggleBorder: '#354451',
        toggleButtonText: '#D0DCEB',

        // user infos
        userInfoText: '#A9B4C1',
        userNameText: '#AFC0D4',

        // word list
        wordList: '#252F38',
        wordListBorder: '#354451',
        wordListBorderFocus: '#AFC0D4',
        wordListBorderHover: '#889DAE',
        wordListItem: '#93AAC52E',
        wordListItemIcon: '#AFC0D4',
        wordListItemIconHover: '#889DAE',
        wordListItemText: '#D0DCEB',

        // metadata
        metadataHeaderText: '#AFC0D4',
        metadataKey: '#AFC0D4',

        // toast
        toastBackgroundDefault: '#A05000',
        toastTextDefault: '#D0DCEB',
        toastBorderDefault: '#A05000',

        toastBackgroundSuccess: '#307A00',
        toastTextSuccess: '#D0DCEB',
        toastBorderSuccess: '#307A00',

        toastBackgroundError: '#9C342E',
        toastTextError: '#D0DCEB',
        toastBorderError: '#9C342E',
    },
    shadows: {
        ...defaults.theme.shadows,
        chatCommandBarTabContainer: 'inset 0px -1px 0px 0px #2B3641',
        chatCommandBarTabFocus: 'inset 0px 0px 0px 2px #FFFFFF',
    },
}

export const defaultsNative = {
    theme: {
        ...shared.theme,
        borderWidths: {
            avatar: 2.5,
            avatarStatus: 1,
            button: 1,
            card: 1,
        },
        colors: {...shared.theme.colors},
        fontSizes: {
            avatarText: 20,
            buttonText: 18,
            messageText: 18,
            messageTimestamp: 14,
            messageUsernameOther: 16,

            modalContentText: 18,
            modalHeaderText: 20,
        },
        radii: {
            avatarBorder: 18,
            avatarStatus: 7,
            button: 7,
            cardBorder: 6,
            messageSpeechBubbleDefault: 12,
            messageSpeechBubbleDefaultCorner: 6,
        },
        sizes: {
            avatar: 36,
            avatarStatus: 14,
            buttonIconSmall: '20',
        },
        space: {
            buttonPaddingHorizontal: 12,
            buttonPaddingHorizontalLarge: 14,
            buttonPaddingHorizontalSmall: 9,
            buttonPaddingVertical: 9,
            buttonPaddingVerticalLarge: 12,
            buttonPaddingVerticalSmall: 5,
            buttonTextMargin: 10,
            messageInfoIconGap: 10,
            messageSpeechBubblePaddingHorizontal: 8,
            messageSpeechBubblePaddingVertical: 4,
            modalHeaderTextMargin: 10,
            modalPaddingHorizontal: 22,
            modalPaddingVertical: 18,
        },
    },
}
